/**
 * Resolve academic data for transcript printing — prefers academics2, falls back to legacy academics (student.academic).
 */

function normTerm(s) {
    return String(s ?? '')
        .trim()
        .toLowerCase();
}

export function findAcademicRecordForTerm(student, selectedTerm) {
    const t = String(selectedTerm ?? '').trim();
    if (!t) return null;
    const tKey = normTerm(t);

    const a2 = Array.isArray(student?.academics2) ? student.academics2 : [];
    const rec2 = a2.find((r) =>
        [r?.termId, r?.termName, r?.term]
            .filter(Boolean)
            .some((v) => normTerm(v) === tKey || String(v) === t)
    );
    if (rec2) return { source: 'academics2', record: rec2 };

    const legacy = Array.isArray(student?.academic) ? student.academic : [];
    const leg = legacy.find((a) => normTerm(a?.term) === tKey || String(a?.term ?? '') === t);
    if (leg) return { source: 'legacy', record: leg };

    return null;
}

export function escapeHtml(s) {
    if (s == null || s === '') return '';
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

/** @returns {{ totalScore: number|string, position: string, aggregate: string, promotion: string }} */
export function transcriptSummaryFromRecord(record, source) {
    if (source === 'academics2') {
        const agg = record.aggregateResults || {};
        return {
            totalScore: agg.totalScore ?? record.totalscore ?? record.totalScore ?? 0,
            position: String(agg.overallPosition ?? record.position ?? 'N/A'),
            aggregate: String(agg.aggregate ?? record.aggregate ?? 'N/A'),
            promotion: String(record.promotion ?? agg.promotion ?? 'N/A'),
        };
    }
    return {
        totalScore: record.totalscore ?? 0,
        position: record.position != null ? String(record.position) : 'N/A',
        aggregate: record.aggregate != null ? String(record.aggregate) : 'N/A',
        promotion: record.promotion != null ? String(record.promotion) : 'N/A',
    };
}
